import { render } from "./BreadCrumb.vue?vue&type=template&id=46f2fee5&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"

import "./BreadCrumb.vue?vue&type=style&index=0&id=46f2fee5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f2fee5"]])

export default __exports__